import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';
import MapNavigation from './Map';
import CompassNavigation from './Compass';
import { useSelector } from 'react-redux';
import { selectIsOnline } from '../../store/slices/global';
import { useUserLocation } from './UserLocation';
import Loader from '../../ui/Loader';
import { getDistance } from '../../helpers';
import { playPointReachedSound } from '../../helpers/sound';
const LocationCheckIn = ({ targetLocation, radius, onTargetCheckedIn, checkedIn, setCheckedIn, }) => {
    const { userPosition, error } = useUserLocation();
    const isOnline = useSelector(selectIsOnline);
    useEffect(() => {
        if (userPosition?.lat && userPosition.lng) {
            const distance = getDistance(userPosition, targetLocation);
            if (distance <= radius) {
                if (!checkedIn) {
                    playPointReachedSound();
                    onTargetCheckedIn(userPosition);
                    setCheckedIn(true);
                }
            }
        }
    }, [userPosition]);
    if (error) {
        return _jsx("p", { className: "form-field-error-message", children: error });
    }
    return (_jsx("div", { className: "location-check-in", children: userPosition?.lat && userPosition.lng ? (isOnline ? (_jsx(MapNavigation, { targetLocation: { lat: targetLocation.lat, lng: targetLocation.lng }, radius: radius, userPosition: userPosition })) : (_jsx(CompassNavigation, { targetLocation: { lat: targetLocation.lat, lng: targetLocation.lng }, userPosition: userPosition }))) : (_jsx(Loader, {})) }));
};
export default LocationCheckIn;
